import React from "react";

import Datetime from "react-datetime";
import moment from "moment";

import FsInput from "./FsInput";

export default class FsDatetime extends FsInput {
  getValueFromUpdate(event) {
    if (!moment.isMoment(event)) {
      return "";
    }

    return event.format("YYYY-MM-DD");
  }

  renderInput() {
    const { formState, attribute, name, dateFormat } = this.props;
    const value = formState.readFormAttribute(attribute);

    return (
      <Datetime
        name={name || attribute}
        inputProps={{ name: name || attribute, id: this.getControlId() }}
        defaultValue={value ? moment(value).format("DD.MM.YYYY") : ""}
        locale="de"
        timeFormat={false}
        dateFormat={dateFormat || "DD.MM.YYYY"}
        onChange={this.update.bind(this)}
        closeOnSelect
      />
    );
  }
}
